export default __webpack_public_path__ + "static/media/1925.80089679.png";